import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

interface ReferralErrorModalProps {
  open: boolean;
  onClose: () => void;
  error: {
    title: string;
    message: string;
    details?: string;
  };
}

export function ReferralErrorModal({
  open,
  onClose,
  error,
}: ReferralErrorModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-md rounded-2xl p-6 shadow-2xl"
        style={{
          backgroundColor: '#1a1a1a',
          border: '2px solid #EF4444',
          boxShadow: '0 0 30px rgba(239, 68, 68, 0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 transition-colors hover:bg-white/10"
          style={{ color: 'white' }}
        >
          <X className="h-5 w-5" />
        </button>

        {/* Error Icon */}
        <div className="mb-4 flex justify-center">
          <div
            className="flex h-16 w-16 items-center justify-center rounded-full"
            style={{
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              border: '2px solid #EF4444',
            }}
          >
            <span
              style={{
                fontSize: '32px',
                color: '#EF4444',
              }}
            >
              ⚠️
            </span>
          </div>
        </div>

        {/* Error Title */}
        <h2
          className="mb-3 text-center text-xl font-bold"
          style={{
            fontFamily: 'Hyperspace Race Capsule, cursive',
            color: '#EF4444',
          }}
        >
          {error.title}
        </h2>

        {/* Error Message */}
        <p
          className="mb-4 text-center text-sm"
          style={{
            fontFamily: 'Outfit, sans-serif',
            color: 'rgba(255, 255, 255, 0.9)',
            lineHeight: '1.6',
          }}
        >
          {error.message}
        </p>

        {/* Error Details (optional) */}
        {error.details && (
          <div
            className="mb-4 rounded-lg p-3"
            style={{
              backgroundColor: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
            }}
          >
            <p
              className="text-xs"
              style={{
                fontFamily: 'Outfit, sans-serif',
                color: 'rgba(255, 255, 255, 0.7)',
                lineHeight: '1.4',
              }}
            >
              {error.details}
            </p>
          </div>
        )}

        {/* Close Button */}
        <button
          onClick={onClose}
          className={cn(
            'w-full rounded-lg py-3 font-semibold transition-all',
            'hover:opacity-90'
          )}
          style={{
            fontFamily: 'Hyperspace Race Capsule, cursive',
            backgroundColor: '#EF4444',
            color: 'white',
          }}
        >
          CLOSE
        </button>
      </div>
    </div>
  );
}

